// extracted by mini-css-extract-plugin
export default {"box-field":"create-reminder_box-field__ORf1T"};